import { __assign } from "tslib";
import React, { useState, useLayoutEffect } from "react";
import { Paper, Table as MaterialTable, TableHead, TableBody, TableRow, TableCell, TablePagination, makeStyles, Backdrop, TableSortLabel, CircularProgress } from "@material-ui/core";
import Cell from "./Cell";
import NoData from "./NoData";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      boxShadow: "none"
    },
    head: {
      background: theme.palette.background.default,
      borderTop: "1px solid ".concat(theme.palette.divider),
      "& th": {
        padding: theme.spacing(1, 2)
      }
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff"
    }
  };
});
var defaultNoData = React.createElement(NoData, null);

var Table = function Table(props) {
  var _a = props.loading,
      loading = _a === void 0 ? false : _a,
      _b = props.hover,
      hover = _b === void 0 ? true : _b,
      _c = props.dataSource,
      dataSource = _c === void 0 ? [] : _c,
      _d = props.renderNoData,
      renderNoData = _d === void 0 ? defaultNoData : _d,
      _e = props.columns,
      columns = _e === void 0 ? [] : _e,
      pagination = props.pagination,
      _f = props.rowsPerPageOptions,
      rowsPerPageOptions = _f === void 0 ? [5, 10, 20] : _f,
      rowClassName = props.rowClassName,
      className = props.className,
      style = props.style,
      onChange = props.onChange,
      onRowClick = props.onRowClick,
      onSort = props.onSort,
      spinColor = props.spinColor;
  var classes = useStyles();

  var _g = useState({}),
      sortState = _g[0],
      setSortState = _g[1];

  useLayoutEffect(function () {
    var initState = {};
    columns.forEach(function (column, index) {
      return initState[String(index)] = column.sortDirection || "desc";
    });
    setSortState(initState);
  }, []);

  function handleSort(key, index, oldValue) {
    var _a;

    var newValue = oldValue === "asc" ? "desc" : "asc";
    var obj = {};
    Object.keys(sortState).forEach(function (key) {
      return obj[key] = sortState[key] || "desc";
    });
    setSortState(__assign(__assign({}, obj), (_a = {}, _a[String(index)] = newValue, _a)));
    onSort && onSort(key || index, newValue);
  }

  function handleRowClick(record, index) {
    onRowClick && onRowClick(record, index);
  }

  return React.createElement(Paper, {
    className: classes.root
  }, React.createElement(MaterialTable, {
    className: className,
    style: style
  }, React.createElement(TableHead, {
    className: classes.head
  }, React.createElement(TableRow, null, columns.map(function (column, index) {
    return React.createElement(TableCell, {
      key: index,
      style: {
        width: column.width || "",
        paddingRight: column.paddingRight === undefined ? "" : column.paddingRight
      }
    }, column.sortable ? React.createElement(TableSortLabel, {
      active: true,
      direction: sortState[String(index)] || "desc",
      onClick: function onClick() {
        handleSort(column.key || column.dataIndex, index, sortState[String(index)]);
      }
    }, column.title) : column.title);
  }))), dataSource.length > 0 && React.createElement(TableBody, null, dataSource.map(function (record, rowIndex) {
    return React.createElement(TableRow, {
      key: rowIndex,
      hover: hover,
      className: rowClassName,
      onClick: function onClick() {
        return handleRowClick(record, rowIndex);
      },
      style: {
        cursor: hover ? "pointer" : "auto"
      }
    }, columns.map(function (column, columnIndex) {
      return React.createElement(TableCell, {
        key: columnIndex,
        style: {
          paddingRight: column.paddingRight === undefined ? "" : column.paddingRight
        }
      }, React.createElement(Cell, {
        node: column,
        record: record,
        index: rowIndex
      }));
    }));
  }))), dataSource.length === 0 && !loading && renderNoData, pagination && React.createElement(TablePagination, {
    component: "div",
    count: pagination.total,
    page: pagination.current - 1,
    rowsPerPage: pagination.pageSize,
    rowsPerPageOptions: rowsPerPageOptions,
    onChangePage: function onChangePage(_, newPage) {
      onChange && onChange(newPage + 1, pagination.pageSize);
    },
    onChangeRowsPerPage: function onChangeRowsPerPage(event) {
      onChange && onChange(1, parseInt(event.target.value));
    }
  }), loading && React.createElement(Backdrop, {
    className: classes.backdrop,
    open: loading
  }, React.createElement(CircularProgress, {
    color: spinColor || "inherit"
  })));
};

export default Table;